exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".qty-buttons-v2[data-v-b69510b0] {\n  padding: 2.5em 0;\n}\n.qty-buttons-v2 > div[data-v-b69510b0] {\n  display: inline-block;\n  vertical-align: top;\n}\n.qty-buttons-v2 .adjustment-btn[data-v-b69510b0] {\n  width: 2.5em;\n  height: 2.5em;\n  border: none;\n  border-radius: 50%;\n  padding: 0.4em;\n  color: #53284f;\n  background-color: #ebebeb;\n}\n.qty-buttons-v2 .adjustment-btn.disabled[data-v-b69510b0] {\n  color: #999;\n}\n.qty-buttons-v2 .month[data-v-b69510b0] {\n  padding: 0.4em 1em;\n}\n", ""]);

// exports
